
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/app/builder",
      function () {
        return require("private-next-pages/app/builder/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/app/builder"])
      });
    }
  